export enum DatacenterId {
  USOregon = 1,
  EUFrankfurt = 2,
  EUIreland = 3,
  APACSingapore = 4,
  SASaoPaulo = 5,
  APACSydney = 7,
}
